<template>
  <IconLucideLock />
</template>
